import { getQueryParam } from 'src/utils/functions';

class TabAccordeon {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => {
			new Section(section);
		});
	}
}

class Section {
	activeAccordeon = null;
	activeTab = null;
	activeItem = null;

	constructor(section) {
		this.section = section;
		this.tabs = this.section.querySelectorAll('.tab-accordeon__tab');
		this.mobileTabs = this.section.querySelectorAll('.tab-accordeon__tab--mobile');
		this.accordeons = this.section.querySelectorAll('.tab-accordeon__accordeon');

		this.activeTab = Array.from(this.tabs).find((tab) => tab.classList.contains('active'));
		this.activeMobileTab = Array.from(this.mobileTabs).find((tab) => tab.classList.contains('active'));
		this.activeAccordeon = Array.from(this.accordeons).find((accordeon) => accordeon.classList.contains('active'));

		this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.setActiveTab(index)));
		this.mobileTabs.forEach((tab, index) => tab.addEventListener('click', () => this.setActiveTab(index)));
		this.accordeons.forEach((accordeon) => {
			const items = accordeon.querySelectorAll('.tab-accordeon__item');
			items.forEach((item, index) => {
				const title = item.querySelector('.tab-accordeon-item__title');
				if (title) {
					title.addEventListener('click', () => this.setActiveItem(index));
				}
			});
		});

		this.initializeFromQueryParam();
	}

	initializeFromQueryParam() {
		const value = getQueryParam('tab');
		for (let i = 0; i < this.tabs.length; i++) {
			const tab = this.tabs[i];
			const accordeon = this.accordeons[i];

			if (tab.dataset.tab === value) {
				this.setActiveTab(i);
				return;
			}

			const items = accordeon.querySelectorAll('.tab-accordeon__item');
			for (let j = 0; j < items.length; j++) {
				const item = items[j];
				if (item.dataset.item === value) {
					this.setActiveTab(i);
					this.setActiveItem(j);
					return;
				}
			}
		}
	}

	setActiveTab(index) {
		const tab = this.tabs[index];
		const isMobile = window.innerWidth <= 768;

		if (!tab) return;

		const isCurrentTab = this.activeTab === tab;

		this.activeTab?.classList.remove('active');
		this.activeTab = tab;
		this.activeTab.classList.add('active');

		this.activeMobileTab?.classList.remove('active');
		this.activeMobileTab = this.mobileTabs[index];
		this.activeMobileTab?.classList.add('active');

		this.activeAccordeon?.classList.remove('active');
		this.activeAccordeon = this.accordeons[index];
		this.activeAccordeon.classList.add('active');

		this.setActiveItem(0);

		// Mobile toggle
		if (isMobile && isCurrentTab) {
			this.activeTab.classList.remove('active');
			this.activeTab = null;

			this.activeMobileTab.classList.remove('active');
			this.activeMobileTab = null;

			this.activeAccordeon.classList.remove('active');
			this.activeAccordeon = null;

			this.setActiveItem(null);
		} else {
			setTimeout(() => this.scrollTo(isMobile ? this.activeMobileTab : this.activeTab), 10);
		}
	}

	setActiveItem(index) {
		const item = this.activeAccordeon?.querySelectorAll('.tab-accordeon__item')[index];

		this.activeItem?.classList.remove('active');
		if (!item || item === this.activeItem) {
			this.activeItem = null;
			return;
		}

		this.activeItem = item;
		this.activeItem.classList.add('active');

		setTimeout(() => this.scrollTo(item), 5);
	}

	scrollTo(element) {
		const headerHeight = 90;
		const yOffset = -headerHeight - 20;
		const rect = element.getBoundingClientRect();
		const top = rect.top + window.scrollY + yOffset;
		window.scrollTo({ top, behavior: 'smooth' });
	}
}

export default TabAccordeon;
